import { BaseResponse } from './internal/baseresponse';
export class TransactionApproveResult extends BaseResponse {
  data: null;
}



// WEBPACK FOOTER //
// ./src/app/response/transactionapproveresult.ts